import { ReactNode } from 'react';
import { Box } from '@mui/material';
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';

export default function HighlightedPrice({
  children,
  renewable = false,
}: {
  children?: ReactNode;
  renewable?: boolean;
}) {
  return (
    <span>
      {renewable && (
        <>
          <CachedRoundedIcon
            sx={(theme) => ({
              color: theme.palette.secondary.light,
              width: '20px',
              height: '20px',
              verticalAlign: 'sub',
              position: 'relative',
              bottom: '-1px',
            })}
          />{' '}
        </>
      )}
      <Box
        component="span"
        sx={(theme) => ({
          color: theme.palette.primary.main,
          fontWeight: 500,
        })}
      >
        {children}
      </Box>
    </span>
  );
}
